module.exports = __webpack_public_path__ + "img/sec-224-bnk.ed4b94f2.svg";